import { useEffect } from "react";

/**
 * Calls `refresh` whenever the tracked generation job's status changes (and
 * when a job starts being tracked). Every status change can move the credit
 * balance: Retry reserves credits again, a failed run is refunded, a trimmed
 * add-on (emotions the provider could not draw) is settled at the end. Keyed on
 * id + status, so progress ticks of a running job do not re-read the balance.
 */
export function useRefreshOnJobStatus(
  jobId: string | null | undefined,
  status: string | null | undefined,
  refresh: () => void
): void {
  const key = jobId && status ? `${jobId}:${status}` : null;
  useEffect(() => {
    if (key) refresh();
  }, [key, refresh]);
}
